// Meta Pixel (Facebook Pixel) tracking utilities

// Check if fbq is available
const isFbqAvailable = () => typeof window !== 'undefined' && typeof window.fbq === 'function';

// Track standard events
export const trackEvent = (eventName, params = {}) => {
  if (isFbqAvailable()) {
    window.fbq('track', eventName, params);
    console.log(`[Meta Pixel] Tracked: ${eventName}`, params);
  }
};

// Track custom events
export const trackCustomEvent = (eventName, params = {}) => {
  if (isFbqAvailable()) {
    window.fbq('trackCustom', eventName, params);
    console.log(`[Meta Pixel] Custom: ${eventName}`, params);
  }
};

// Standard Facebook Pixel Events

// When user signs up or logs in
export const trackLead = (params = {}) => {
  trackEvent('Lead', params);
};

// When user views pricing/plans page
export const trackInitiateCheckout = (params = {}) => {
  trackEvent('InitiateCheckout', params);
};

// When user completes purchase/subscription
export const trackPurchase = (value, currency = 'BRL', params = {}) => {
  trackEvent('Purchase', { value, currency, ...params });
};

// When user starts trial
export const trackStartTrial = (params = {}) => {
  trackEvent('StartTrial', params);
};

// When user adds payment info
export const trackAddPaymentInfo = (params = {}) => {
  trackEvent('AddPaymentInfo', params);
};

// When user completes registration
export const trackCompleteRegistration = (params = {}) => {
  trackEvent('CompleteRegistration', params);
};

// When user views content
export const trackViewContent = (contentName, contentCategory = '', params = {}) => {
  trackEvent('ViewContent', { 
    content_name: contentName,
    content_category: contentCategory,
    ...params 
  });
};

// When user searches
export const trackSearch = (searchString, params = {}) => {
  trackEvent('Search', { search_string: searchString, ...params });
};

// Custom events for Evite Dívidas

// When user starts expense organizer
export const trackStartOrganizer = () => {
  trackCustomEvent('StartOrganizer');
};

// When user adds first expense
export const trackFirstExpense = () => {
  trackCustomEvent('FirstExpense');
};

// When user upgrades from trial
export const trackTrialUpgrade = () => {
  trackCustomEvent('TrialUpgrade');
};

export default {
  trackEvent,
  trackCustomEvent,
  trackLead,
  trackInitiateCheckout,
  trackPurchase,
  trackStartTrial,
  trackAddPaymentInfo,
  trackCompleteRegistration,
  trackViewContent,
  trackSearch,
  trackStartOrganizer,
  trackFirstExpense,
  trackTrialUpgrade
};
